import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {AmendReplaceLatestModalComponent} from './amend-replace-latest-modal.component';

@Injectable({
    providedIn: 'root'
})
export class AmendReplaceLatestModalService extends ModalService {
    showAmendReplaceLatestModal(title: string, message: string) {
        this.createModalComponent(AmendReplaceLatestModalComponent);
        const amendModalComponent = this.modalComponentRef.instance as AmendReplaceLatestModalComponent;
        amendModalComponent.title = title;
        amendModalComponent.message = message;
        this.showModalComponent();
        return amendModalComponent.modalClosed;
    }
}
